/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Meta_Notfoundtitle2Inputs */

const id_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil tidak ditemukan`)
};

const ms_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil tidak ditemui`)
};

const da_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil ikke fundet`)
};

const de_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil nicht gefunden`)
};

const en_us2_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile not found`)
};

const es_es2_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil no encontrado`)
};

const es_mx2_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil no encontrado`)
};

const fil_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nahanap ang profile`)
};

const fr_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil non trouvé`)
};

const it_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo non trovato`)
};

const hu_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil nem található`)
};

const nl_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiel niet gevonden`)
};

const no_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil ikke funnet`)
};

const pl_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil nie znaleziony`)
};

const pt_br2_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil não encontrado`)
};

const pt_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil não encontrado`)
};

const ro_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil negăsit`)
};

const fi_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiilia ei löydy`)
};

const sv_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilen hittades inte`)
};

const vi_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy hồ sơ`)
};

const tr_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil bulunamadı`)
};

const cs_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil nenalezen`)
};

const bg_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профилът не е намерен`)
};

const ru_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль не найден`)
};

const uk_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профіль не знайдено`)
};

const ar_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الملف الشخصي غير موجود`)
};

const hi_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल नहीं मिली`)
};

const th_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบโปรไฟล์`)
};

const ja_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィールが見つかりません`)
};

const zh_cn2_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人资料未找到`)
};

const zh_hant1_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人資料未找到`)
};

const ko_profile_meta_notfoundtitle2 = /** @type {(inputs: Profile_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로필을 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "Profile not found" |
*
* @param {Profile_Meta_Notfoundtitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_meta_notfoundtitle2 = /** @type {((inputs?: Profile_Meta_Notfoundtitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Meta_Notfoundtitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_meta_notfoundtitle2(inputs)
	if (locale === "ms") return ms_profile_meta_notfoundtitle2(inputs)
	if (locale === "da") return da_profile_meta_notfoundtitle2(inputs)
	if (locale === "de") return de_profile_meta_notfoundtitle2(inputs)
	if (locale === "en-US") return en_us2_profile_meta_notfoundtitle2(inputs)
	if (locale === "es-ES") return es_es2_profile_meta_notfoundtitle2(inputs)
	if (locale === "es-MX") return es_mx2_profile_meta_notfoundtitle2(inputs)
	if (locale === "fil") return fil_profile_meta_notfoundtitle2(inputs)
	if (locale === "fr") return fr_profile_meta_notfoundtitle2(inputs)
	if (locale === "it") return it_profile_meta_notfoundtitle2(inputs)
	if (locale === "hu") return hu_profile_meta_notfoundtitle2(inputs)
	if (locale === "nl") return nl_profile_meta_notfoundtitle2(inputs)
	if (locale === "no") return no_profile_meta_notfoundtitle2(inputs)
	if (locale === "pl") return pl_profile_meta_notfoundtitle2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_meta_notfoundtitle2(inputs)
	if (locale === "pt") return pt_profile_meta_notfoundtitle2(inputs)
	if (locale === "ro") return ro_profile_meta_notfoundtitle2(inputs)
	if (locale === "fi") return fi_profile_meta_notfoundtitle2(inputs)
	if (locale === "sv") return sv_profile_meta_notfoundtitle2(inputs)
	if (locale === "vi") return vi_profile_meta_notfoundtitle2(inputs)
	if (locale === "tr") return tr_profile_meta_notfoundtitle2(inputs)
	if (locale === "cs") return cs_profile_meta_notfoundtitle2(inputs)
	if (locale === "bg") return bg_profile_meta_notfoundtitle2(inputs)
	if (locale === "ru") return ru_profile_meta_notfoundtitle2(inputs)
	if (locale === "uk") return uk_profile_meta_notfoundtitle2(inputs)
	if (locale === "ar") return ar_profile_meta_notfoundtitle2(inputs)
	if (locale === "hi") return hi_profile_meta_notfoundtitle2(inputs)
	if (locale === "th") return th_profile_meta_notfoundtitle2(inputs)
	if (locale === "ja") return ja_profile_meta_notfoundtitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_meta_notfoundtitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_meta_notfoundtitle2(inputs)
	return ko_profile_meta_notfoundtitle2(inputs)
});
export { profile_meta_notfoundtitle2 as "profile.meta.notFoundTitle" }